/* global axios */

// Capture the full scope before awaiting, as for message translation: the
// account-scoped URL can otherwise change while the agent switches accounts.
function scopedUrl({ accountId, conversationId, messageId }) {
  const ids = [accountId, conversationId, messageId].map(Number);
  if (!ids.every(value => Number.isSafeInteger(value) && value > 0)) {
    throw new Error('Invalid video transcription scope');
  }
  const [account, conversation, message] = ids;
  return `/api/v1/accounts/${account}/conversations/${conversation}/messages/${message}/video_transcription`;
}

export async function requestVideoTranscription(scope) {
  const response = await axios.post(scopedUrl(scope));
  return response.data;
}

export async function fetchVideoTranscription(scope) {
  const response = await axios.get(scopedUrl(scope));
  return response.data;
}
